module.exports = __webpack_public_path__ + "static/media/araiInfo.6dc859f1.svg";